import React from "react";
import Dialog, { DialogProps } from "./Dialog";
import Item, { ItemProps } from "./Item";

type MenuItem =
  | { type: "Item"; itemProps: ItemProps }
  | { type: "Dialog"; dialogProps: DialogProps };

type MenuItemRendererProps = {
  menuItems: MenuItem[];
};

const MenuItemRenderer: React.FC<MenuItemRendererProps> = ({ menuItems }) => {
  return (
    <>
      {menuItems.map((menuItem, index) => {
        switch (menuItem.type) {
          case "Item":
            return <Item {...menuItem.itemProps} key={index} />;
          case "Dialog":
            return <Dialog {...menuItem.dialogProps} key={index} />;
          default:
            return null;
        }
      })}
    </>
  );
};

export default MenuItemRenderer;
